import axios from 'axios';
import apiZelo from '../backAxiosVendaToken';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');

let retorno;
export const api = axios.create({
    baseURL: url,
    headers: { 'x-auth-token': token }
});

export const InserirAssociado = async value => {
    try {
        const response = await apiZelo.post(
            '/Associados/create',
            value
        );

        return response.data;
    } catch (error) {
        return {
            error,
            message: error.message
        };
    }
};

export const InserirAvisos = async assoc => {
    await fetch(`${url}/avisos/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        },
        body: JSON.stringify(assoc)
    })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson) {
                retorno = responseJson;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err;
        });

    return retorno;
};

export const BuscarAvisos = async () => {
    await fetch(`${url}/avisos/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson) {
                retorno = responseJson;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err;
        });

    return retorno;
};
